// Client-side analytics: UTM capture, download click tracking, scroll depth,
// contact email tracking. All calls wrapped in try/catch — nothing here can
// break site functionality.

(function () {
  'use strict';

  var UTM_KEY    = 'stint_utm';
  var UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  // ── UTM capture (session-scoped) ──────────────────────────────────────────
  function captureUtms() {
    try {
      var params = new URLSearchParams(window.location.search);
      var utm = {};
      var found = false;
      UTM_FIELDS.forEach(function (k) {
        var v = params.get(k);
        if (v) { utm[k] = v; found = true; }
      });
      if (found) sessionStorage.setItem(UTM_KEY, JSON.stringify(utm));
    } catch (e) {}
  }

  function getUtms() {
    try {
      var raw = sessionStorage.getItem(UTM_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) { return {}; }
  }

  // ── Fire to all platforms ─────────────────────────────────────────────────
  function fireEvent(eventName, extraParams) {
    var utm    = getUtms();
    var params = Object.assign({}, utm, extraParams || {});

    // GA4
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      }
    } catch (e) {}

    // Meta Pixel
    try {
      if (typeof window.fbq === 'function') {
        var metaName = metaEventName(eventName);
        var metaData = Object.assign({ content_name: eventName }, params);
        if (metaName === eventName) {
          window.fbq('trackCustom', eventName, metaData);
        } else {
          window.fbq('track', metaName, metaData);
        }
      }
    } catch (e) {}

    // Fathom
    try {
      if (window.fathom && typeof window.fathom.trackEvent === 'function') {
        window.fathom.trackEvent(fathomLabel(eventName, extraParams));
      }
    } catch (e) {}

    // TikTok
    try {
      if (typeof window.ttq === 'object' && typeof window.ttq.track === 'function') {
        window.ttq.track(tiktokEventName(eventName), Object.assign({ content_name: eventName }, params));
      }
    } catch (e) {}
  }

  function metaEventName(n) {
    if (n === 'app_download_stinter' || n === 'app_download_partner') return 'Lead';
    if (n === 'contact_page_send_email') return 'Contact';
    if (n === 'page_scroll_vertical')    return 'ViewContent';
    if (n === 'stinter_video_open')      return 'ViewContent';
    if (n === 'stinter_video_progress')  return 'ViewContent';
    return n;
  }

  function tiktokEventName(n) {
    if (n === 'app_download_stinter' || n === 'app_download_partner') return 'Download';
    if (n === 'contact_page_send_email') return 'Contact';
    if (n === 'stinter_video_open' || n === 'stinter_video_progress') return 'ViewContent';
    return 'ViewContent';
  }

  function fathomLabel(n, params) {
    if (n === 'app_download_stinter') return 'App Download: Stinter (' + ((params && params.location) || 'unknown') + ')';
    if (n === 'app_download_partner') return 'App Download: Partner (' + ((params && params.location) || 'unknown') + ')';
    if (n === 'contact_page_send_email') return 'Contact: Email Click';
    if (n === 'page_scroll_vertical') return 'Scroll ' + (params && params.percent_scrolled) + '%';
    if (n === 'stinter_video_open') return 'Stinter Video: Open (' + ((params && params.video_title) || 'unknown') + ')';
    if (n === 'stinter_video_progress') return 'Stinter Video: ' + (params && params.video_percent) + '% (' + ((params && params.video_title) || 'unknown') + ')';
    return n;
  }

  // ── Download button detection ─────────────────────────────────────────────
  // IDs that mean "stinter app download, location derived from ID"
  var STINTER_ID_MAP = {
    'download_app_stinter_page_apple':   { location: 'hero_apple',   platform: 'ios' },
    'download_app_stinter_page_android': { location: 'hero_android', platform: 'android' },
    'download_app_stinter_get_started':  { location: 'get_started',  platform: 'redirect' },
    'download_app_stinter_cta':          { location: 'cta',          platform: 'redirect' },
    'footer_stinter_app':                { location: 'footer',       platform: 'redirect' },
    'footer_stinter_app_mobile':         { location: 'footer',       platform: 'redirect' },
    'slideout_apple':                    { location: 'slideout',     platform: 'ios' },
    'slideout_android':                  { location: 'slideout',     platform: 'android' }
  };

  var PARTNER_ID_MAP = {
    'footer_partner_app':        { location: 'footer',   platform: 'redirect' },
    'footer_partner_app_mobile': { location: 'footer',   platform: 'redirect' },
    'contact_partner_app':       { location: 'contact',  platform: 'redirect' }
  };

  function platformFromHref(href) {
    if (!href) return 'redirect';
    if (href.indexOf('apple.com') !== -1)       return 'ios';
    if (href.indexOf('play.google.com') !== -1) return 'android';
    return 'redirect';
  }

  document.addEventListener('click', function (e) {
    try {
      var el = e.target.closest('a');
      if (!el) return;

      var id   = el.id || '';
      var href = el.getAttribute('href') || '';

      // Stinter app — known IDs
      if (STINTER_ID_MAP[id]) {
        var info = STINTER_ID_MAP[id];
        fireEvent('app_download_stinter', {
          event_category: 'app_download',
          location:        info.location,
          platform:        info.platform,
          app_type:        'stinter'
        });
        return;
      }

      // Partner app — known IDs
      if (PARTNER_ID_MAP[id]) {
        var pinfo = PARTNER_ID_MAP[id];
        fireEvent('app_download_partner', {
          event_category: 'app_download',
          location:        pinfo.location,
          platform:        pinfo.platform,
          app_type:        'partner'
        });
        return;
      }

      // Fallback: stinter redirect URLs without a recognised ID
      if (href.indexOf('/redirect_to_app') !== -1) {
        fireEvent('app_download_stinter', {
          event_category: 'app_download',
          location:        id || 'unknown',
          platform:        'redirect',
          app_type:        'stinter'
        });
        return;
      }

      // Fallback: partner redirect URLs without a recognised ID
      if (href.indexOf('partner_app_redirect') !== -1) {
        fireEvent('app_download_partner', {
          event_category: 'app_download',
          location:        id || 'unknown',
          platform:        'redirect',
          app_type:        'partner'
        });
      }
    } catch (eOuter) {}
  }, true);

  // ── Scroll depth ──────────────────────────────────────────────────────────
  var scrollFired = {};
  var scrollTicking = false;

  function checkScrollDepth() {
    try {
      var doc        = document.documentElement;
      var body       = document.body;
      var scrollTop  = doc.scrollTop || body.scrollTop;
      var maxScroll  = Math.max(doc.scrollHeight, body.scrollHeight) - doc.clientHeight;
      var pct        = maxScroll > 0 ? Math.round((scrollTop / maxScroll) * 100) : 100;

      [25, 50, 75, 100].forEach(function (t) {
        if (!scrollFired[t] && pct >= t) {
          scrollFired[t] = true;
          fireEvent('page_scroll_vertical', {
            percent_scrolled: t,
            page_path:        window.location.pathname
          });
        }
      });
    } catch (e) {}
  }

  window.addEventListener('scroll', function () {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      checkScrollDepth();
      scrollTicking = false;
    });
  }, { passive: true });

  // ── Contact email click ───────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    try {
      var el = e.target.closest('a[href^="mailto:"]');
      if (!el) return;
      fireEvent('contact_page_send_email', {
        email_address: el.getAttribute('href').replace('mailto:', ''),
        page_path:     window.location.pathname
      });
    } catch (e2) {}
  });

  // ── Promo nav CTA click tracking ─────────────────────────────────────────
  function trackNavApplyClick(record) {
    try {
      // Use the promotions controller's trackEvent directly — gives us the
      // correct session_id, ref attribution, and external analytics all in one.
      if (typeof window.promoTrackEvent === 'function') {
        window.promoTrackEvent(
          'nav_apply_click',
          record.slug,
          record.campaign_slug || null,
          { location: 'nav', apply_url: record.apply_url, page_path: window.location.pathname }
        );
      }
    } catch(e) {}
  }

  function wireNavApplyClick() {
    document.addEventListener('click', function(e) {
      try {
        var el = e.target.closest('#nav-promo-apply-desktop, #nav-promo-apply-mobile a');
        if (!el) return;
        var raw = localStorage.getItem('stint_promo_nav') || sessionStorage.getItem('stint_promo_nav');
        if (!raw) return;
        var record = JSON.parse(raw);
        if (record && record.apply_url) trackNavApplyClick(record);
      } catch(e2) {}
    });
  }

  // ── Promo nav CTA ─────────────────────────────────────────────────────────
  function revealPromoCta() {
    try {
      var raw = localStorage.getItem('stint_promo_nav') || sessionStorage.getItem('stint_promo_nav');
      if (!raw) return;

      var record = JSON.parse(raw);
      if (!record || !record.apply_url) return;

      // Remove if expired
      if (record.expires_at && new Date(record.expires_at) < new Date()) {
        localStorage.removeItem('stint_promo_nav');
        sessionStorage.removeItem('stint_promo_nav');
        return;
      }

      var label = record.apply_label || 'Apply Now';

      // Desktop
      var desktop = document.getElementById('nav-promo-apply-desktop');
      if (desktop) {
        desktop.setAttribute('href', record.apply_url);
        desktop.textContent = label;
        desktop.style.display = '';
      }

      // Mobile
      var mobile = document.getElementById('nav-promo-apply-mobile');
      if (mobile) {
        var mLink = mobile.querySelector('a');
        if (mLink) {
          mLink.setAttribute('href', record.apply_url);
          mLink.textContent = label;
        }
        mobile.style.display = '';
      }
    } catch (e) {}
  }

  // ── Public API ───────────────────────────────────────────────────────────
  window.stintFireEvent = fireEvent;

  // ── Boot ──────────────────────────────────────────────────────────────────
  var navClickWired = false;
  function boot() {
    captureUtms();
    revealPromoCta();
    if (!navClickWired) { wireNavApplyClick(); navClickWired = true; }
    // Reset scroll tracking on each page navigation
    scrollFired = {};
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('turbolinks:load', boot);
  document.addEventListener('turbo:load', boot);

})();
